import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthGroupService } from 'apps/hospital-admin/src/app/auth-group/+state/auth-group.service';
import { InitializeAuthGroupSignal } from 'apps/hospital-admin/src/app/auth-group/+state/auth-group.signals';
import { AUTH_GROUPS } from 'apps/hospital-admin/src/app/auth-group/constants';
import { filter, switchMap, tap } from 'rxjs';

export const payrollExportsGuard: CanActivateFn = () => {
  const authGroupService = inject(AuthGroupService);
  const router = inject(Router);
  const store = inject(Store);

  store.dispatch(new InitializeAuthGroupSignal({}));

  return authGroupService
    .isLoaded()
    .pipe(
      filter((isLoaded) => isLoaded),
      switchMap(() => authGroupService.getOfficerBelongsToAuthGroup(AUTH_GROUPS.PAYROLL_OFFICER)),
    )
    .pipe(tap((hasGroup) => hasGroup || router.navigateByUrl('dashboard')));
};
